import styled from 'styled-components'
const OrderSummariesDashboardWrapper = styled.div`
  .margin-bottom-8 { margin-bottom: 8px; }
  .padding-0 { padding: 0 !important; }
`

export default OrderSummariesDashboardWrapper
